/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogColor } from "../../d-dialog-color";
import { DThemeWhiteDialogFitted } from "./d-theme-white-dialog-fitted";

export class DThemeWhiteDialogColor extends DThemeWhiteDialogFitted implements DThemeDialogColor {}
